// Add Touch Class to root for Touch Devices
function touchClass(e){
    document.querySelector('html').classList.add('touch');
	window.removeEventListener('touchstart', touchClass);
}
window.addEventListener('touchstart',touchClass);

// Click Event delegation
window.addEventListener('click', event => {
    let {target} = event; 

    if(target.matches('[href*="#live-chat"]')){
        event.preventDefault();
        if(window.Tawk_API){
            Tawk_API.showWidget();
            Tawk_API.maximize();
        }
    }
}, false);

// Scrolled Check
if (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
        [
            ['top','body > header']
            //,['bottom','body > footer > section']
        ].forEach( ([className,triggerElement]) => {
            (new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    document.body.classList.add(className);
                } else {
                    document.body.classList.remove(className);
                }
            },{threshold:[0]})).observe(document.querySelector(triggerElement));
        });
}